<template>
  <section
    ref="section20"
    :class="[(Object.keys(validationErrors).length > 0 ? 'has-errors' : ''), 'mx-auto flex h-full flex-col']"
  >
    <v-add-listing-head
      :routes="routes"
      :step="17"
    ></v-add-listing-head>
    <main
      class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
    >

      <figure class="relative flex max-w-3xl flex-col gap-11 lg:w-full">
        <figure class="ml-auto mr-auto flex w-full max-w-lg gap-3">
          <div><v-icon icon="water-pump" size="8"></v-icon></div>
          <div class="flex flex-col justify-center">
            <div class="mb-3 mr-6 text-heading-3-desktop">Komunalni priključki</div>
            <div class="text-body-regular text-black-40">
              Izberite kako je vaša parcela priključena na komunalne priključke:
            </div>
          </div>

          <!-- <v-lightbox is-authenticated footerless>
            <template v-slot:trigger>
                <div
                    class="absolute right-0 top-0 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-green-25"
                >
                    <v-icon icon="question-mark" size="4"></v-icon>
                </div>
            </template>
            <template v-slot:head>
                <div class="flex items-start">
                    <v-icon
                        icon="question-mark"
                        class="mr-2.5"
                        size="4.5"
                    ></v-icon>
                    <div>
                        Dodatne informacije
                    </div>
                </div>
            </template>
            <template v-slot:content>
              <p class="mb-[10px] text-icon-text-medium">
                  Komunalni priključki
              </p>
              <p class="mb-8 text-body-regular">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi molestie elit id libero congue porttitor. In ut est ac eros consequat posuere at et leo. Nulla sed enim eget ex interdum facilisis. Nam nec ipsum nec magna tincidunt bibendum. Cras dolor nulla, sagittis eget augue in, auctor varius nunc.
              </p>
            </template>
          </v-lightbox> -->
        </figure>
        <figure class="ml-auto mr-auto w-full">
          <form method="POST" :action="routes.submitForm" id="select-utility-connection">
            <v-csrf-token></v-csrf-token>
            <figure
              class="grid grid-cols-1 grid-rows-1 gap-4 lg:flex lg:grid-cols-2 lg:flex-wrap lg:justify-center lg:gap-4 lg:gap-6"
            >
              <div
                name="komunalniPrikljuckiPrikljucenaVCeloti"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.erschliessung ? 'has-errors' : '')]"
              >
                <input
                  type="radio"
                  name="erschliessung"
                  id="komunalniPrikljuckiPrikljucenaVCeloti"
                  value="erschlossen"
                  class="hidden"
                  v-model="utilityConnection"
                />
                <label
                  for="komunalniPrikljuckiPrikljucenaVCeloti"
                  class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                >
                  <v-icon icon="circle-check" size="5"></v-icon>
                  <span class="pointer-events-none select-none lg:flex-1"
                    >Priključena v celoti</span
                  >
                </label>
              </div>
              <div
                name="komunalniPrikljuckiDelnoPrikljucena"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.erschliessung ? 'has-errors' : '')]"
              >
                <input
                  type="radio"
                  name="erschliessung"
                  id="komunalniPrikljuckiDelnoPrikljucena"
                  value="teilerschlossen"
                  class="hidden"
                  v-model="utilityConnection"
                />
                <label
                  for="komunalniPrikljuckiDelnoPrikljucena"
                  class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                >
                  <v-icon icon="partial" size="5"></v-icon>

                  <span class="pointer-events-none select-none lg:flex-1"
                    >Delno priključena</span
                  >
                </label>
              </div>
              <div
                name="komunalniPrikljuckiNiPrikljucena"
                :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.erschliessung ? 'has-errors' : '')]"
              >
                <input
                  type="radio"
                  name="erschliessung"
                  id="komunalniPrikljuckiNiPrikljucena"
                  value="unerschlossen"
                  class="hidden"
                  v-model="utilityConnection"
                />
                <label
                  for="komunalniPrikljuckiNiPrikljucena"
                  class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                >
                  <v-icon icon="cancel" size="5"></v-icon>

                  <span class="pointer-events-none select-none lg:flex-1"
                    >Ni priključena</span
                  >
                </label>
              </div>
            </figure>
          </form>
        </figure>
      </figure>
    </main>
    <v-add-listing-foot>
      <a
        @click="submitForm('select-utility-connection')"
        :class="['button button--md h-[48px] w-[240px] px-6', (validated ? '' : 'button button--gray')]"
      >
        <label class="text-small-text-medium">Nadaljujte</label>
        <v-icon icon="arrow-right" size="4"></v-icon>
      </a>
    </v-add-listing-foot>
  </section>
</template>
<script>
import AddListingFootVue from '../AddListingFoot.vue';
import AddListingHeadVue from '../AddListingHead.vue';

export default {
  components: {
    "v-add-listing-foot": AddListingFootVue,
    "v-add-listing-head": AddListingHeadVue,
  },
  props: {
    old: {
      type: Object,
      required: false,
      default: {},
    },
    routes: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
      default: {},
    },
    stepData: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
    return {
      utilityConnection: null,
    };
  },
  mounted() {
    this.utilityConnection = this.stepData.erschliessung
  },
  computed: {
  },
  methods: {
    submitForm(formId) {
      if(this.validated) document.getElementById(formId).submit();
    },
  },
  computed: {
    validated() {
      if(this.utilityConnection == null) return false

      return true;
    }
  },
};
</script>
